import { render, staticRenderFns } from "./CalendarBlack.vue?vue&type=template&id=8282178a&scoped=true&"
var script = {}
import style0 from "./CalendarBlack.vue?vue&type=style&index=0&id=8282178a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8282178a",
  null
  
)

export default component.exports